import { render } from "./ModuleReplace.vue?vue&type=template&id=072ec91b&scoped=true"
import script from "./ModuleReplace.vue?vue&type=script&lang=js"
export * from "./ModuleReplace.vue?vue&type=script&lang=js"

import "./ModuleReplace.vue?vue&type=style&index=0&id=072ec91b&lang=scss&scoped=true"
import "./ModuleReplace.vue?vue&type=style&index=1&id=072ec91b&lang=scss"

import exportComponent from "C:\\Users\\klegrand-ext\\Documents\\intratoneinfov4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072ec91b"]])

export default __exports__